module.exports = "/virtual-football-league/img/amblems/right/logos/REAL BETIS.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/REAL BETIS.png
// module id = 2220
// module chunks = 4